<div [class]="isZoomed ? 'image-zoom' : 'w-100 h-100'">
  @if ((widgetConfig && show && (this.overlayActive || !this.overlay)) || showImage) {
  <div class="image-wrapper" [style]="mergedOuterCss" (click)="goToNavigationLink()">
    @if (showExpandView) {
    <div class="f-right p-2" (click)="toggleZoom($event)">
      <img alt="expand" src="assets/images/expand.svg" />
    </div>
    }
  </div>
  }
</div>